import { jsx as _jsx } from "react/jsx-runtime";
import { ParentSize } from "@visx/responsive";
import { Wordcloud } from "@visx/wordcloud";
import { Text as CloudText } from "@visx/text";
import { getColourForCategory } from "../../../helpers/CategoryHelper";
import { EmptyState } from "@mantine/core";
import { WarningIcon } from '@phosphor-icons/react';
export default function DisplayCloud(_a) {
    var items = _a.items;
    if (items.length === 0) {
        return _jsx(EmptyState, { mt: "md", icon: _jsx(WarningIcon, {}), title: "No words found", description: "We couldn't find any words added before the chosen date." });
    }
    return _jsx("div", { style: { width: '100%', height: '400px' }, children: _jsx(ParentSize, { children: function (_a) {
                var width = _a.width, height = _a.height;
                return (_jsx(Wordcloud, { width: width, height: height, words: items, fontSize: function (w) { return w.size; }, rotate: 0, font: "Impact", children: function (cloudWords) {
                        return cloudWords.map(function (w, i) { return (_jsx(CloudText, { fill: getColourForCategory(w.category), transform: "translate(".concat(w.x, ", ").concat(w.y, ") rotate(").concat(w.rotate, ")"), fontSize: w.size, fontFamily: w.font, textAnchor: "middle", children: w.text }, i)); });
                    } }));
            } }) });
}
